import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-313e0153"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]

import { onMounted } from "vue";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const store = useStore();
onMounted(() => {
  console.log("Home->onMounted");
});

return (_ctx: any,_cache: any) => {
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_el_main, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_card, { class: "box-main" }, {
            default: _withCtx(() => [
              _createElementVNode("p", {
                innerHTML: _unref(store).state.pageContents
              }, null, 8, _hoisted_1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})